import { OfflineOperation } from 'src/app/services/offline/offline-storage.service';
import {
  StoreForwardAttemptRequest,
  StoreForwardOperationRequest,
} from './store-forward.types';

const ENDPOINT_SET_VALUES = '/api/transportista/viajes/set-values';
const ENDPOINT_SET_VALUES_CLIENTE = '/api/transportista/viajes/cliente/set-values';
const ENDPOINT_FIRMA = '/api/transportista/viajes/firma';

const ENDPOINT_BY_TYPE: Partial<Record<OfflineOperation['type'], string>> = {
  signedCanvas: ENDPOINT_FIRMA,
  signed: ENDPOINT_SET_VALUES,
  extraValues: ENDPOINT_SET_VALUES,
  extraField: ENDPOINT_SET_VALUES,
  statusUpdate: ENDPOINT_SET_VALUES,
  unsigned: ENDPOINT_SET_VALUES,
  clearPending: ENDPOINT_SET_VALUES,
  rejected: ENDPOINT_SET_VALUES,
};

export function mapOfflineOpToTipoOperacion(type: OfflineOperation['type']): string {
  if (type === 'signed' || type === 'signedCanvas') {
    return 'FIRMA';
  }
  return 'SET_VALUES';
}

export function mapOfflineOpToModulo(type: OfflineOperation['type']): string {
  if (type === 'signed' || type === 'signedCanvas') {
    return 'FIRMA_DIGITAL';
  }
  return 'TRANSPORTISTA';
}

export function mapOfflineOpToEndpointDestino(op: OfflineOperation): string {
  if (op.type === 'rejected' && !op.payload.isMixer) {
    return ENDPOINT_SET_VALUES_CLIENTE;
  }
  return ENDPOINT_BY_TYPE[op.type] ?? ENDPOINT_SET_VALUES;
}

export function pickTicketFromOp(op: OfflineOperation): string | undefined {
  const payload = op.payload as { tkt?: string; orderNumber?: string };
  return payload?.tkt != null ? String(payload.tkt) : undefined;
}

export function pickPedidoFromOp(op: OfflineOperation): string | undefined {
  const payload = op.payload as { orderNumber?: string };
  return payload?.orderNumber != null ? String(payload.orderNumber) : undefined;
}

export function buildOperationRequest(
  op: OfflineOperation,
  operationId: string,
  enrich: Partial<StoreForwardOperationRequest>
): StoreForwardOperationRequest {
  const ticket = pickTicketFromOp(op);
  const pedido = pickPedidoFromOp(op);
  return {
    operationId,
    tipoOperacion: mapOfflineOpToTipoOperacion(op.type),
    modulo: mapOfflineOpToModulo(op.type),
    dispositivoId: enrich.dispositivoId ?? '',
    ticket,
    pedido,
    endpointDestino: mapOfflineOpToEndpointDestino(op),
    fechaCreacionLocal: new Date(op.queuedAt ?? Date.now()).toISOString(),
    cantidadIntentos: op.retryCount ?? 0,
    estado: 'PENDIENTE',
    correlationId: op.correlationId,
    usuarioId: enrich.usuarioId,
    rolUsuario: enrich.rolUsuario,
    estadoConectividad: enrich.estadoConectividad,
    versionAplicacion: enrich.versionAplicacion,
    sistemaOperativo: enrich.sistemaOperativo,
    ...enrich,
  };
}

export function buildAttemptRequest(
  attemptId: string,
  operationId: string,
  numeroIntento: number,
  partial: Partial<StoreForwardAttemptRequest>
): StoreForwardAttemptRequest {
  return {
    attemptId,
    operationId,
    numeroIntento,
    fechaIntentoLocal: new Date().toISOString(),
    resultado: partial.resultado ?? 'PENDIENTE',
    codigoHttp: partial.codigoHttp,
    codigoError: partial.codigoError,
    mensaje: partial.mensaje,
    detalleTecnico: partial.detalleTecnico,
    estadoConectividad: partial.estadoConectividad,
    duracionMs: partial.duracionMs,
    datosAdicionales: partial.datosAdicionales,
  };
}
